import api from '@/shared/api';
import type { Branch, SingleBranchResponse } from '@/entities/Branch/model/branch.types';
import type { AxiosResponse } from 'axios';

class BranchApi {
  async getUserBranches(): Promise<{ branches: Branch[]; currentBranchId?: number }> {
    try {
      const response = await api.get('/branches/me');
      return {
        branches: response.data.data.branches || [],
        currentBranchId: response.data.data.currentBranchId,
      };
    } catch (error) {
      console.error('Error fetching user branches:', error);
      throw error;
    }
  }
  async getBranchById(branchId: number | string): Promise<Branch> {
    try {
      const response = await api.get<SingleBranchResponse>(`/branches/${branchId}`);
      return response.data.data;
    } catch (error) {
      console.error('Error fetching branch:', error);
      throw error;
    }
  }

  async deleteBranch(branchId: number): Promise<AxiosResponse<any>> {
    try {
      const response = await api.delete(`/branches/${branchId}`);
      return response;
    } catch (error) {
      console.error('Error deleting branch:', error);
      throw error;
    }
  }

  async createBranch(formData: FormData): Promise<any> {
    try {
      const response = await api.post('/branches', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error creating branch:', error);
      throw error;
    }
  }

  async updateBranch(branchId: number | string, formData: FormData): Promise<any> {
    try {
      const response = await api.put(`branches/${branchId}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error updating branch:', error);
      throw error;
    }
  }
}

export const branchApi = new BranchApi();
